import BaseModel from './BaseModel';
import { sumBy } from 'lodash';
export default class Airport extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.IATA = data.iata || data.id;
        this.ICAO = data.icao || data.ICAO;
        this.name = data.name || this.translate.name || undefined;
        this.cityId = data.cityId || this.translate.cityId || undefined;
        this.cityName = data.cityName || this.translate.cityName || undefined;
        this.countryId = data.countryId || this.translate.countryId || undefined;
        this.countryName = data.countryName || this.translate.countryName || undefined;
        this.isDomestic = data.isDomestic || this.translate.isDomestic || true;
        this.order = data.order || this.translate.order || 0;
        this.provinceName = data.provinceName || this.translate.provinceName || '';
        this.createdDate = data.createdDate || undefined;
        this.isDisplay = data.isDisplay || false;
        this.airportDisplayType = this.convertAirportDisplayTypeToArray(data.airportDisplayType);
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            IATA: this.id,
            ICAO: this.ICAO,
            name: this.name,
            cityId: this.cityId,
            cityName: this.cityName,
            countryId: this.countryId,
            countryName: this.countryName,
            isDomestic: this.isDomestic,
            order: this.order,
            provinceName: this.provinceName,
            isDisplay: this.isDisplay,
            airportDisplayType: this.convertArrayToAirportDisplayType(this.airportDisplayType)
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id || this.id,
                airportId: this.translate.airportId || this.id,
                name: this.name,
                cityName: this.cityName,
                countryName: this.countryName,
                languageCode: this.languageCode,
                order: this.order,
                provinceName: this.provinceName,
            }
        }
        return result;
    }

    convertAirportDisplayTypeToArray = (number) => {
        const array = [];
        switch (number) {
            case 1:
                return [1];
            case 2:
                return [2];
            case 3:
                return [1, 2];
            default:
                return [];
        }
    }

    convertArrayToAirportDisplayType = (array) => {
        return sumBy(array);
    }
}
